import React from 'react';

const ResetPasswordSuccess = () => {
	return(
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
			<h1>Your Password Has Been Successfully changed, Please login in With your new Password</h1>
		</div>
	)
}

export default ResetPasswordSuccess;